import React from 'react';

interface CardProps {
  children: React.ReactNode;
  padding?: string;
  interactive?: boolean;
  noPad?: boolean;
  className?: string;
}

export function Card({ children, padding, interactive, noPad, className = '' }: CardProps) {
  const padClass = noPad ? '' : (padding ?? 'p-4');
  return (
    <div
      className={[
        'bg-surface dark:bg-surface-dark',
        'border border-line dark:border-line-dark',
        'rounded-card shadow-sm-warm dark:shadow-sm-dark',
        interactive ? 'cursor-pointer transition-shadow hover:shadow-md-warm dark:hover:shadow-md-dark' : '',
        padClass,
        className,
      ].join(' ')}
    >
      {children}
    </div>
  );
}
